import { B as u, r as c, n as l } from "./abstract-base-CzLmw6_x.js";
import { B as f } from "./beacon-primitive-ChVMWFlW.js";
import { g as p } from "./uid-HAKIZOcY.js";
var g = Object.defineProperty, n = (s, i, a, t) => {
  for (var e = void 0, r = s.length - 1, o; r >= 0; r--)
    (o = s[r]) && (e = o(i, a, e) || e);
  return e && g(i, a, e), e;
};
const h = "beacon-table";
class d extends f(u) {
  constructor() {
    super(...arguments), this.isOriginal = !0, this.uuid = p();
  }
  /** When using transformed cards, this stores all nodes associated with the current one via their identical UUID. */
  get pairedNodes() {
    const { beaconTagName: i, uuid: a } = this, t = `[uuid="${a}"]`, e = `${this.getScopedTagName(i)}${t}`;
    if (this.isOriginal) {
      const r = this.closest(this.getScopedTagName(h));
      if (!r)
        return;
      const o = r.transformedCardsContainer;
      return o ? o.querySelectorAll(e) : void 0;
    }
    return document.querySelectorAll(e);
  }
  willUpdate(i) {
    i.forEach((a, t) => {
      var e;
      this.pairedNodes && t !== "isOriginal" && (!this.isOriginal && t === "bold" || (e = this.pairedNodes) == null || e.forEach((r) => {
        r[t] = this[t];
      }));
    });
  }
}
n([
  c()
], d.prototype, "isOriginal");
n([
  l({ reflect: !0 })
], d.prototype, "uuid");
export {
  d as B
};
